export const tasksListData = [
    {
        title: "Video conference with Canada Team ",
        description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
        priority: "high",
        priorityColor: "danger",
        priorityBgColor: "soft-danger",
        taskType: "Call",
        taskTypeColor: "primary",
        taskTypeBgColor: "soft-primary",
        user_img: "/images/avatar/1.png",
        date: new Date()
    },
    {
        title: "Client objective meeting ",
        description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
        priority: "normal",
        priorityColor: "primary",
        priorityBgColor: "soft-primary",
        taskType: "Conferences",
        taskTypeColor: "success",
        taskTypeBgColor: "soft-success",
        user_img: "/images/avatar/2.png",
        date: new Date()
    },
    {
        title: "Target market trend analysis on the go ",
        description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
        priority: "medium",
        priorityColor: "warning",
        priorityBgColor: "soft-warning",
        taskType: "meetings",
        taskTypeColor: "teal",
        taskTypeBgColor: "soft-teal",
        user_img: "/images/avatar/3.png",
        date: new Date()
    },
    {
        title: "Send revised proposal to Mr. Dow Jones ",
        description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
        priority: "low",
        priorityColor: "success",
        priorityBgColor: "soft-success",
        taskType: "calls",
        taskTypeColor: "primary",
        taskTypeBgColor: "soft-primary",
        user_img: "/images/avatar/4.png",
        date: new Date()
    },
    {
        title: "Set up first call for demo ",
        description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
        priority: "urgent",
        priorityColor: "danger",
        priorityBgColor: "soft-danger",
        taskType: "Project",
        taskTypeColor: "warning",
        taskTypeBgColor: "soft-warning",
        user_img: "/images/avatar/5.png",
        date: new Date()
    },



    {
        title: "Client objective meeting ",
        description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
        priority: "normal",
        priorityColor: "primary",
        priorityBgColor: "soft-primary",
        taskType: "Conferences",
        taskTypeColor: "success",
        taskTypeBgColor: "soft-success",
        user_img: "/images/avatar/2.png",
        date: new Date(new Date().setDate(new Date().getDate() - 1))
    },
    {
        title: "Target market trend analysis on the go ",
        description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
        priority: "medium",
        priorityColor: "warning",
        priorityBgColor: "soft-warning",
        taskType: "meetings",
        taskTypeColor: "teal",
        taskTypeBgColor: "soft-teal",
        user_img: "/images/avatar/3.png",
        date: new Date(new Date().setDate(new Date().getDate() - 1))
    },
    {
        title: "Send revised proposal to Mr. Dow Jones ",
        description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
        priority: "low",
        priorityColor: "success",
        priorityBgColor: "soft-success",
        taskType: "calls",
        taskTypeColor: "primary",
        taskTypeBgColor: "soft-primary",
        user_img: "/images/avatar/4.png",
        date: new Date(new Date().setDate(new Date().getDate() - 1))
    },



    {
        title: "Target market trend analysis on the go ",
        description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
        priority: "medium",
        priorityColor: "warning",
        priorityBgColor: "soft-warning",
        taskType: "meetings",
        taskTypeColor: "teal",
        taskTypeBgColor: "soft-teal",
        user_img: "/images/avatar/3.png",
        date: new Date(new Date().setDate(new Date().getDate() - 2))
    },
    {
        title: "Client objective meeting ",
        description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
        priority: "normal",
        priorityColor: "primary",
        priorityBgColor: "soft-primary",
        taskType: "Conferences",
        taskTypeColor: "success",
        taskTypeBgColor: "soft-success",
        user_img: "/images/avatar/2.png",
        date: new Date(new Date().setDate(new Date().getDate() - 3))
    },
    {
        title: "Send revised proposal to Mr. Dow Jones ",
        description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
        priority: "low",
        priorityColor: "success",
        priorityBgColor: "soft-success",
        taskType: "calls",
        taskTypeColor: "primary",
        taskTypeBgColor: "soft-primary",
        user_img: "/images/avatar/4.png",
        date: new Date(new Date().setDate(new Date().getDate() - 4))
    },
    {
        title: "Set up first call for demo ",
        description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
        priority: "urgent",
        priorityColor: "danger",
        priorityBgColor: "soft-danger",
        taskType: "Project",
        taskTypeColor: "warning",
        taskTypeBgColor: "soft-warning",
        user_img: "/images/avatar/5.png",
        date: new Date(new Date().setDate(new Date().getDate() - 4))
    },
];

export const tasksCommentsData = [
    {
        user_name: "Alexandra Della",
        user_img: "/images/avatar/1.png",
        time: "57 Min Ago",
        like: "6",
        replies: [
            {
                user_name: "Marianne Audrey",
                user_img: "/images/avatar/2.png",
                time: "50 Min Ago",
                like: "",
                replie: 'Wishing calling is warrant settled was lucky.',
                replies: []
            },
            {
                user_name: "Curtis Green",
                user_img: "/images/avatar/3.png",
                time: "45 Min Ago",
                like: "2",
                replie: 'Removed demands expense account in outward tedious do. Particular way thoroughly unaffected projection.',
                replies: []
            },
            {
                user_name: "Curtis Green",
                user_img: "/images/avatar/2.png",
                time: "45 Min Ago",
                like: "2",
                replie: 'Removed demands expense account in outward tedious do. Particular way thoroughly unaffected projection.',
                replies: []
            },
            {
                user_name: "Curtis Green",
                user_img: "/images/avatar/2.png",
                time: "45 Min Ago",
                like: "2",
                replie: 'Removed demands expense account in outward tedious do. Particular way thoroughly unaffected projection.',
                replies: []
            },
            {
                user_name: "Curtis Green",
                user_img: "/images/avatar/2.png",
                time: "45 Min Ago",
                like: "2",
                replie: 'Removed demands expense account in outward tedious do. Particular way thoroughly unaffected projection.',
                replies: []
            },
        ],
        comments: "Removed demands expense account in outward tedious do. Particular way thoroughly unaffected projection.",
    },

    {
        user_name: "Holland Scott",
        user_img: "/images/avatar/4.png",
        time: "42 Min Ago",
        like: "8",
        replies: [],
        comments: "See resolved goodness felicity shy civility domestic had but Drawings offended yet answered Jennings perceive.",
    },
    {
        user_name: "Olive Delarosa",
        user_img: "/images/avatar/5.png",
        time: "34 Min Ago",
        like: "8",
        replies: [],
        comments: "Dependent on so extremely delivered by. Yet no jokes worse her why.",
    },

]